import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import { trackExperiment } from '../new-lib/analytics';
import { useSelector } from 'react-redux';

const useTrackExperiment = (experimentName: string) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  useEffect(() => {
    const experimentStarted = localStorage?.getItem('experiment_started');

    if (isMobile && (!experimentStarted || experimentStarted !== 'true')) {
      const experimentVariant = new Cookies().get('_ab');
      localStorage.setItem('experiment_started', 'true');
      trackExperiment(experimentName, experimentVariant);
    }
  }, []);
};

export default useTrackExperiment;
